import { render, staticRenderFns } from "./productingPackageStatus.vue?vue&type=template&id=a596f8f6&scoped=true&"
import script from "./productingPackageStatus.vue?vue&type=script&lang=js&"
export * from "./productingPackageStatus.vue?vue&type=script&lang=js&"
import style0 from "./productingPackageStatus.vue?vue&type=style&index=0&id=a596f8f6&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a596f8f6",
  null
  
)

export default component.exports